<template>
	<div>
		<template class="price-box" v-if="limitpricetype === '0'">
			<el-row type="flex" justify="space-between">
				<span>{{ item.label }}</span>
				<div>
					<span class="g-require-icon">*</span><span>限价标准</span>
					<el-input size="small" class="price-input" v-model="item.value" placeholder="请输入" type="number" @blur="onBlur"></el-input>
					<i @click="onDelete" style="font-size: 20px;cursor: pointer" class="g-margin-left el-icon-remove-outline"></i>
				</div>
			</el-row>
		</template>
		<template v-if="limitpricetype === '1'">
			<el-row class="price-item">
				<el-col :span="10">{{ item.label }}</el-col>
				<el-col :span="12">
					<el-row>
						<el-col :span="12" style="text-align: right" v-for="limitItem in item.limitData" :key="limitItem.platform">
							<div>
								<span class="g-require-icon">*</span><span>{{ limitItem.label }}限价标准</span>
								<el-input size="small" class="price-input" v-model="limitItem.value" placeholder="请输入" type="number" @blur="e => onBlur(e, limitItem.platform)"></el-input>
							</div>
						</el-col>
					</el-row>
				</el-col>
				<el-col :span="2" class="g-center">
					<i @click="onDelete" style="font-size: 20px;cursor: pointer" class="g-margin-left el-icon-remove-outline"></i>
				</el-col>
			</el-row>
		</template>
	</div>
</template>

<script>
export default {
	name: '',

	components:{},

	props: {
		limitpricetype: {
			type: String
		},
		item: {
			type: Object
		}
	},

	data () {
		return {
		}
	},

	methods: {
		onBlur(e, platform) {
			let value = parseFloat(e.target.value)
			if(value < 0) {
				this.$message.error('限价不能小于0');
				e.target.value = 0
			}
			e.target.value = value.toFixed(2)
			this.$emit('onBlur', {
				value: value.toFixed(2),
				platform
			})
		},
		onDelete() {
			this.$emit('on-delete')
		}
	},

	computed: {},

	mounted(){
	}
}
</script>

<style lang="scss">
@import "style/activityDeclaration.scss";
@import "style/myInfomation.scss";

.price-item {
	display: flex;
	align-items: center;
}

.price-input {
	widows: 120px;
}

</style>